import React from 'react'
import Form from '../EarlyPurchase/Form'

const StudentInfoEntry = () => {
  return (
    <Form />
  )
};

export default StudentInfoEntry;
